import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'sa-label',
  templateUrl: './sa-label.component.html',
  styleUrls: ['../formfields.css']
})
export class SaLabelComponent implements OnInit {
  @Input() text = "";
  @Input() title = "";

  @Output() textChange = new EventEmitter();
  @Output() hasChanged = new EventEmitter();
  
  isValid = true;
  tiClass = { 'border': 'solid 1px gray' }; // {'background-color':'green'};
  constructor() { }

  ngOnInit() {
  }
  ngAfterViewChecked() {
  }


}
